import Vue from 'vue'
import App from './App.vue'

import router from './router'

import '@fortawesome/fontawesome-free/scss/fontawesome.scss'
import '@fortawesome/fontawesome-free/scss/solid.scss'
import '@fortawesome/fontawesome-free/scss/brands.scss'

import Logger from './modules/Logger'

Vue.config.productionTip = false
const LOG_LEVEL = 'DEBUG'
const logger = new Logger('Dashboard', LOG_LEVEL)
Vue.prototype.$logger = logger

new Vue({
  router,
  render: (h) => h(App)
}).$mount('#app')
